import styled from 'styled-components';
import { Button } from 'style/buttons';

export const ChooseButton = styled(Button)`
    height: 28px;
    padding: 5px;
    font-size: 12px;
    margin: 2px 5px;
`;

export const SingleSelectorContainer = styled.div<{readOnly?: boolean}>`
    width: auto;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: 'center';
    justify-content: 'flex-start';
    gap: 20px;
    flex-direction: column;
    pointer-events: ${(props) => props.readOnly ? 'none' : 'auto'};
`;